import createVueApp from '@/common/createApp'
import sidebar from '@/config/sidebars/adminSettings'

// Styxie derives name from Admin::Settings::MobileApps::VersionsController → AdminSettingsMobileAppsVersions
Styxie.Initializers.AdminSettingsMobileAppsVersions = {
  show: async(props) => {
    const { default: ShowPage } = await import('@/vue_widgets/admin/settings/mobile_apps/versions/show/index.vue')
    createVueApp(ShowPage, { props, sidebar })
  },
  new: async(props) => {
    const { default: FormPage } = await import('@/vue_widgets/admin/settings/mobile_apps/versions/form.vue')
    createVueApp(FormPage, { props, sidebar })
  },
  edit: async(props) => {
    const { default: FormPage } = await import('@/vue_widgets/admin/settings/mobile_apps/versions/form.vue')
    createVueApp(FormPage, { props, sidebar })
  }
}
